import { COUNTRY, Country } from '@/types/api/common';

export const privacyPolicyLinkMap: Record<Country, string> = {
  [COUNTRY.NORWAY]: 'https://www.eneas.no/gdpr-privacy-policy/',
  [COUNTRY.SWEDEN]: 'https://www.eneas.se/gdpr-integritetspolicy/',
  [COUNTRY.FINLAND]: 'https://www.venienergia.fi/tietosuojalauseke/',
  [COUNTRY.SPAIN]: 'https://www.eneas.no/gdpr-privacy-policy/', // TODO: change to correct privacy policy
  [COUNTRY.GERMANY]: 'https://www.gu-veni.de/gdpr-privacy-policy/',
};

// This is now all using the same feedback form link, but if we want to separate the countries we can use this
export const feedbackFormLinkMap: Record<Country, string> = {
  [COUNTRY.NORWAY]: 'https://forms.cloud.microsoft/e/0kZ6ZLh9Vg',
  [COUNTRY.SWEDEN]: 'https://forms.cloud.microsoft/e/0kZ6ZLh9Vg',
  [COUNTRY.FINLAND]: 'https://forms.cloud.microsoft/e/0kZ6ZLh9Vg',
  [COUNTRY.SPAIN]: 'https://forms.cloud.microsoft/e/0kZ6ZLh9Vg',
  [COUNTRY.GERMANY]: 'https://forms.cloud.microsoft/e/0kZ6ZLh9Vg',
};
